module.exports = "<!-- PRINCIPAIS PROPOSTAS-->\n<h2 class=\"text-title\">Pesquisas</h2>\n<div class=\"list-group\">\n  <div class=\"col-sm-12 card\" *ngFor=\"let item of itens | async\">\n    <app-pesquisa-show [item]=\"item\"></app-pesquisa-show>\n  </div>\n</div>\n<br>\n<a  class=\"btn btn-outline-primary\" routerLink=\"/pesquisa\" role=\"button\">Ver Mais</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home-pesquisa/home-pesquisa.component.html
// module id = ./src/app/home/home-pesquisa/home-pesquisa.component.html
// module chunks = main